import 'intersection-observer';
var uid = 0;
export function BindObserverMixin(handler, options) {
    var key = 'observer_'.concat(uid++);

    if ('IntersectionObserver' in window) {
        var observe = function observe() {
            var _this = this;

            if (!this.observer) {
                this.observer = new IntersectionObserver(function(entries) {
                    handler.call(_this, entries, _this.observer);
                }, options.call(this));
            }

            if (!this[key]) {
                this.observer.observe(this.$el);
                this[key] = true;
            }
        };

        var unobserve = function unobserve() {
            if (this[key]) {
                this.observer.unobserve(this.$el);
                this[key] = false;
            }
        };

        var disconnect = function disconnect() {
            this.observer.disconnect();
        };

        return {
            mounted: observe,
            activated: observe,
            deactivated: unobserve,
            beforeDestroy: disconnect
        };
    } else {
        throw new Error("This device isn't support IntersectionObserver");
    }
}
